export enum Role {
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  AGENCY_ADMIN = 'AGENCY_ADMIN',
  DISPATCHER = 'DISPATCHER',
  VIEWER = 'VIEWER',
  FIRST_RESPONDER = 'FIRST_RESPONDER',
  EMPLOYEE = 'EMPLOYEE',
}

export enum UserStatus {
  INACTIVE = 'INACTIVE',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export interface IUserRole {
  agency?: string;
  role: Role;
}

export interface IUser {
  _id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  password?: string;
  status: UserStatus;
  latsLoggedIn?: Date;
  roles: IUserRole[];
  profile?: string;
  fullName?: string;
  agency?: string;
}

export interface IAdminForm {
  _id?: string;
  email: string;
  agency: string;
}
